<template>
    <transition name="fade-in" mode="out-in">
        <div v-if="notificationBar.visible" class="notification-app-bar" :style="{ 'width': width }">
            <div :class="['notification-app-bar__notification', progressCls]">
                <i :class="[progressIcon, 'm-r-16']"></i>
                <p>{{ progressText }}</p>
            </div>
            <div class="notification-app-bar__actions">
                <a-button class="m-r-24" type="primary" @click="doAction">{{ btnSave }}</a-button>
                <i class="fal fa-times fz-18 text-color-secondary cursor-pointer" @click="onCancel"></i>
            </div>
        </div>
    </transition>
</template>
<script>
export default {
    name: 'VueNotificationBar',
    props: {
        value: {
            type: Object,
            required: true
        },
        noWatchWidth: Boolean
    },
    data() {
        return {
            width: '100%'
        }
    },
    computed: {
        notificationBar: {
            get() {
                return this.value
            },
            set( value ) {
                this.$emit('input', value)
            }
        },
        progressText () {
            if (this.notificationBar.text) { return this.notificationBar.text }
            switch (this.notificationBar.type) {
                case 'images-limit':
                    return `Available image has reached its limit, please buy more images to continue optimize.`
                break;
                default:
                return `Please wait ...`
            }
        },
        progressIcon () {
            if (this.notificationBar.iconClass) { return this.notificationBar.iconClass }
            switch (this.notificationBar.type) {
                default:
                return `fas fa-exclamation-triangle`
            }
        },
        progressCls () {
            return `notification-app-bar__` + this.notificationBar.type
        },
        btnSave() {
            if (this.notificationBar.btnSave) { 
                return this.notificationBar.btnSave 
            } else {
                return 'Save'
            }
        }
    },
    mounted() {
        if (!this.noWatchWidth) {
            this.calculateWidth()
            window.addEventListener('resize', this.calculateWidth)
        }
    },
    beforeDestroy() {
        if (!this.noWatchWidth) {
            window.removeEventListener('resize', this.calculateWidth)
        }
    },
    created() {
    },
    methods: {
        calculateWidth() {
        let ele = document.querySelector('.app-layout__body')
            if (ele) {
                this.width = ele.clientWidth + 'px'
            }
        },
        doAction() {
            this.$emit('doAction')
        },
        onCancel() {
            this.$emit('onCancel')
        }
    }
}
</script>
<style lang="scss">
    .notification-app-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        z-index: 600;
        box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
        padding: 22px 24px;
        height: 64px;
        position: fixed;
        top: 0;
        background: $white-color;
        .fa-exclamation-triangle {
            color: $warning-color;
        }
        &__notification{
            display: flex;
            padding-right: 20px;
            i{
                margin-top: 4px;
            }
            p{
                margin-bottom: 0;
            }
        }
        &__actions{
            display: flex;
            align-items: center;
        }
    }
</style>